import React from 'react';
import { getCategoryColor, getCategoryLabel } from 'config/ideaCategories';
import { Lightning, Gauge } from '@phosphor-icons/react';

export default function CategorySlide({ sectionNumber, category, ideas }) {
    const color = getCategoryColor(category);
    const label = getCategoryLabel(category);

    return (
        <div className="h-full w-full bg-[#d6d6d6] p-8 md:p-16 overflow-y-auto relative">
            {/* Logo */}
            <div className="absolute top-8 right-8 md:top-16 md:right-16">
                <img
                    src="/images/opificioai-logo.png"
                    alt="OpificioAI"
                    className="h-6 md:h-8 w-auto opacity-60"
                />
            </div>

            <div className="max-w-6xl mx-auto">
                {/* Section Number */}
                <div className="text-[80px] md:text-[120px] font-bold text-black/10 leading-none mb-4">
                    {sectionNumber}
                </div>

                {/* Category Header */}
                <div className="flex items-center gap-4 mb-12">
                    <div
                        className="w-6 h-6 rounded-full"
                        style={{ backgroundColor: color }}
                    />
                    <h2 className="text-3xl md:text-5xl font-bold text-black/90">
                        {label}
                    </h2>
                    <span className="text-2xl text-black/40 font-medium">
                        ({ideas.length} {ideas.length === 1 ? 'idea' : 'idee'})
                    </span>
                </div>

                {/* Ideas Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {ideas.map((idea, index) => {
                        const ease = idea.ease || (10 - idea.difficulty + 1);
                        return (
                            <div
                                key={idea._id || index}
                                className="bg-white rounded-2xl p-6 shadow-sm"
                            >
                                <h3 className="text-xl font-semibold text-black/90 mb-4">
                                    {idea.title}
                                </h3>

                                {idea.description && (
                                    <p className="text-black/60 text-sm mb-4 line-clamp-2">
                                        {idea.description}
                                    </p>
                                )}

                                <div className="flex items-center gap-6">
                                    <div className="flex items-center gap-2">
                                        <Lightning size={18} weight="fill" className="text-amber-500" />
                                        <span className="text-sm text-black/50">Impatto:</span>
                                        <span className="text-lg font-bold text-black/80">{idea.impact}</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <Gauge size={18} weight="fill" className="text-emerald-500" />
                                        <span className="text-sm text-black/50">Facilità:</span>
                                        <span className="text-lg font-bold text-black/80">{ease}</span>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
